module.exports = __webpack_public_path__ + "img/horizontal_3_4_1.74c2dfa5.png";